import { useContext } from 'react'
import { TypographyContext } from './TypographyProvider'

const useContainerTypography = () => {
  const provider = useContext(TypographyContext)
  return provider ?? {}
}

export { useContainerTypography }
